import React from 'react';
import styled from 'styled-components';

import { conceptAvailability, describeConceptDatasets } from './constants';

const TooltipList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: left;
`;

const DatasetLine = styled.div<{ isMuted: boolean }>`
  opacity: ${(props) => (props.isMuted ? 0.55 : 1)};
  white-space: nowrap;
`;

// What a concept resolves to, one dataset per line, ticked where this account
// actually has it. With no dataset list to judge against we show the names and
// claim nothing.
const ConceptTooltip = ({
  concept,
  accountDatasetTypes,
}: {
  concept: AgentEval.DatasetConcept;
  accountDatasetTypes: string[] | null;
}) => {
  const datasets = describeConceptDatasets({ concept, accountDatasetTypes });
  const availability = conceptAvailability({ concept, accountDatasetTypes });
  const heading =
    availability === 'present'
      ? 'On this account:'
      : availability === 'absent'
        ? 'None of these are on this account:'
        : 'Satisfied by any of:';

  return (
    <TooltipList>
      <div>{heading}</div>
      {datasets.map(({ dataset, isPresent }) => (
        <DatasetLine
          key={dataset}
          isMuted={isPresent === false}
          data-testid="concept-dataset-line"
        >
          {isPresent === true ? '✓ ' : isPresent === false ? '— ' : ''}
          {dataset}
        </DatasetLine>
      ))}
    </TooltipList>
  );
};

export default ConceptTooltip;
